<template>
  <b-container fluid class="m-0 p-0">
    <!-- :::::::::::::::::::::::::::: NOTIFICADOR :::::::::::::::::::::::::::: -->
    <notificador-card />
    <!-- :::::::::::::::::::::::::::: SIDEBAR :::::::::::::::::::::::::::: -->
    <orcamento-sidebar
      @limparOrcamento="limparOrcamento()"
      @listaDeOrcamentos="listaDeOrcamentos()"
      @setModelo="setModelo($event)"
      @addItem="addItem()"
      @delItem="delItem()"
      @listarProdutos="listarProdutos()"
      @usarComoModelo="usarComoModelo()"
      @salvar="salvar()"
    />
    <!-- :::::::::::::::::::::::::::: ORCAMENTO HEAD :::::::::::::::::::::::::::: -->
    <div id="orcamento-body">
      <h3 class="m-2">{{ orcamento.titulo }}</h3>
      <div id="formularioDeOrcamento" class="orcamento-form-print">
        <div id="header-oc">
          <div v-if="modelo === 'netech'">
            <img height="220" :src="require('/static/images/header-netech.png')" />
          </div>
          <div v-if="modelo === 'netelog'">
            <img height="220" :src="require('/static/images/header-netelog.png')" />
          </div>
          <div v-if="modelo === 'deb'">
            <img height="220" :src="require('/static/images/header-deb.png')" />
          </div>
          <div>
            <b-row class="text-left p-0">
              <b-col class="p-0" cols="12">
                <b-button class="w-100 p-1 pr-3 text-right text-tabela" @click="setHead()" size="lg" variant="dark" squared>
                  <strong>
                    {{
                      "Orçamento Nº " +
                      orcamento.id +
                      ", " +
                      orcamento.local +
                      " - " +
                      moment(orcamento.data).format("DD/MM/YYYY")
                    }}
                  </strong>
                </b-button>
              </b-col>
              <b-col cols="12" class="mt-2">
                <p class="m-0"><strong>À</strong></p>
              </b-col>
              <b-col cols="12" class="m-0">
                <p class="m-0">{{ orcamento.cliente }}</p>
              </b-col>
              <b-col cols="12" class="m-0">
                <p class="m-0"><strong>Aos cuidados de</strong></p>
              </b-col>
              <b-col cols="12" class="m-0">
                <p class="m-0">{{ orcamento.responsavel }}</p>
              </b-col>
            </b-row>
          </div>
        </div>
        <!-- :::::::::::::::::::::::::::: ORCAMENTO BODY :::::::::::::::::::::::::::: -->
        <div id="body-oc" class="m-0 p-0">
          <b-row>
            <b-col cols="5"></b-col>
            <b-col cols="2">
              <h4 class="font-weight-bold">ORÇAMENTO</h4>
            </b-col>
            <b-col cols="12">
              <p>Atendendo a sua solicitação, apresentamos nossa proposta orçamentária para os serviços relacionados abaixo.</p>
            </b-col>
          </b-row>
        </div>
        <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
        <div>
          <b-table hover small :items="orcamento.itens" :fields="fields.orcamentoItem">
            <template #cell(codigo)="data">
              <div>
                <b-form-textarea v-model="data.item.codigo" class="text-tabela" />
              </div>
            </template>

            <template #cell(descricao)="data">
              <div>
                <b-form-textarea v-model="data.item.descricao" rows="3" class="text-tabela" />
              </div>
            </template>

            <template #cell(unidade)="data">
              <div>
                <b-form-input v-model="data.item.unidade" class="text-tabela" />
              </div>
            </template>

            <template #cell(quantidade)="data">
              <div>
                <b-form-input v-model="data.item.quantidade" type="number" @blur="calcularTotal()" class="text-tabela" />
              </div>
            </template>

            <template #cell(valor)="data">
              <div>
                <b-form-input v-model="data.item.valor" v-money="money" @blur="calcularTotal()" class="text-tabela" />
              </div>
            </template>

            <template #cell(total)="data">
              <div>
                <b-form-input v-model="data.item.total" v-money="money" class="text-tabela" />
              </div>
            </template>
          </b-table>
        </div>
        <!-- :::::::::::::::::::::::::::: DESCONTO E TOTAL :::::::::::::::::::::::::::: -->
        <div>
          <b-row class="mt-2">
            <b-col offset="7" cols="5">
              <b-form-group label="Desconto(%):" label-for="desconto" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="desconto" v-model="orcamento.desconto" @blur="calcularTotal()" class="text-tabela" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col offset="7" cols="5">
              <b-form-group label="Total:" label-for="total" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="total" v-model.lazy="orcamento.total" v-money="money" class="text-tabela" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <!-- :::::::::::::::::::::::::::: DETALHES FINAIS :::::::::::::::::::::::::::: -->
        <div>
          <b-row class="mt-2">
            <p class="m-0"><strong>DETALHES DA PROPOSTA</strong></p>
          </b-row>
          <b-row>
            <b-form-textarea v-model="orcamento.observacao" rows="14" class="text-tabela" />
          </b-row>
          <b-row class="justify-content-center mt-5">
            <h5 v-if="modelo === 'netech'"><strong>NEW ENERGY TECH - NETECH</strong></h5>
            <h5 v-if="modelo === 'netelog'"><strong>NEW ENERGY LOGISTIC - NETELOG</strong></h5>
            <h5 v-if="modelo === 'deb'"><strong>DeB Ambiental - D&B</strong></h5>
          </b-row>
          <b-row class="justify-content-center mt-2">
            <h5 class="m-0"><strong>Deoclides Farias Galvão</strong></h5>
          </b-row>
          <b-row class="justify-content-center">
            <p>Diretor Financeiro</p>
          </b-row>
        </div>
      </div>
      <!-- :::::::::::::::::::::::::::: ORCAMENTO MODALS :::::::::::::::::::::::::::: -->
      <orcamento-head-modal ref="head" />
      <orcamento-list-modal ref="listaOrcamentos" @setOrcamento="setOrcamento($event)" />
      <confirm-modal ref="confirm" :descricao="'Deseja realmente remover o último item ?'" @executar="executar()" />
      <produto-list ref="produtoList" @addProduto="addProduto($event)" />
    </div>
  </b-container>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useOrcamentoStore } from "@/stores/OrcamentoStore";
import { storeToRefs } from "pinia";
import { VMoney } from "v-money";
import Orcamento from "@/models/Orcamento";
import OrcamentoItem from "@/models/OrcamentoItem";
import TableFields from "@/tools/TableFields";
import Notificador from "@/components/supports/Notificador";
import Notificacao from "@/models/Notificacao";
import OrcamentoSideBar from "@/components/bars/OrcamentoSideBar";
import OrcamentoHead from "@/components/modals/orcamento/OrcamentoHead";
import OrcamentoList from "@/components/modals/orcamento/OrcamentoList";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";
import ProdutoListModal from "@/components/modals/orcamento/ProdutoListModal.vue";

export default {
  name: "PaginaDosOrcamentos",

  components: {
    "notificador-card": Notificador,
    "orcamento-sidebar": OrcamentoSideBar,
    "orcamento-head-modal": OrcamentoHead,
    "orcamento-list-modal": OrcamentoList,
    "confirm-modal": ConfirmModal,
    "produto-list": ProdutoListModal,
  },

  directives: { money: VMoney },

  data() {
    return {
      format: require("date-format"),
      modelo: "netech",
      orcamento: new Orcamento(),
      fields: new TableFields(),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  methods: {
    addItem() {
      this.orcamento.itens.push(
        new OrcamentoItem(0, this.orcamento.itens.length + 1, "Descreva o novo item", 1, "Und", 0.0, 0.0)
      );
    },

    delItem() {
      this.$refs.confirm.call();
    },

    executar() {
      if (this.orcamento.itens.length > 0) {
        let lastElement = this.orcamento.itens.pop();
        if (lastElement.id != 0) {
          this.orcamentoStore.REMOVER_ITEM_ORCAMENTO(lastElement.id).then(() => {
            this.calcularTotal();
            this.salvar();
            //Notificar
            this.store.NOTIFICAR(new Notificacao("Item removido permanentemente do SGCQ!", "Atenção!", "warning"));
          });
        }
      }
    },

    listarProdutos() {
      this.$refs.produtoList.call();
    },

    addProduto(produto) {
      produto.valor = parseFloat(produto.valor).toFixed(2);
      this.orcamento.itens.push(
        new OrcamentoItem(0, produto.codigo, produto.descricao, 1, produto.unidade, produto.valor, produto.valor)
      );
    },

    usarComoModelo() {
      this.orcamento.id = 0;
      this.orcamento.itens.forEach((item) => {
        item.id = 0;
      });
      //Notificar
      this.store.NOTIFICAR(new Notificacao("Um novo orçamento foi criado com o modelo selecionado!", "Atenção!", "info"));
    },

    calcularTotal() {
      this.orcamento.calcularTotal();
    },

    setHead() {
      this.$refs.head.call(this.orcamento);
    },

    setModelo(modelo) {
      this.modelo = modelo;
    },

    setOrcamento(orcamento) {
      this.orcamentoStore.LISTAR_ITEM_ORCAMENTO(orcamento).then(() => {
        this.orcamento.update(this.getOrcamento(orcamento.id));
      });
    },

    listaDeOrcamentos() {
      this.$refs.listaOrcamentos.call(this.orcamento);
    },

    limparOrcamento() {
      this.orcamento.update(new Orcamento());
    },

    salvar() {
      if (this.orcamento.id != 0) {
        this.orcamentoStore.ALTERAR_ORCAMENTO(this.orcamento);
      } else {
        this.orcamentoStore.CADASTRAR_ORCAMENTO(this.orcamento).then(() => {
          this.orcamento.id = this.getLastOrcamento.id;
          this.orcamento.itens.forEach((item) => {
            this.orcamentoStore.CADASTRAR_ITEM_ORCAMENTO(this.orcamento.id, item);
          });
        });
      }
      //Notificar
      this.store.NOTIFICAR(new Notificacao("Orçamento salvo no SGCQ com sucesso!", "Excelente!", "success"));
    },
  },

  setup() {
    const store = useSgcqStore();
    const orcamentoStore = useOrcamentoStore();
    const { getLastOrcamento } = storeToRefs(orcamentoStore);
    const { getOrcamento } = storeToRefs(orcamentoStore);

    return {
      store,
      orcamentoStore,
      getLastOrcamento,
      getOrcamento,
      usuario: store.getUser,
    };
  },
};
</script>

<style lang="scss" scoped>
#orcamento-body {
  display: inline-block;
  width: 80%;
  vertical-align: top;
  overflow-x: hidden;
  overflow-y: scroll;
  min-width: 80%;
  height: 99vh;
}

.orcamento-form-print {
  margin-left: 3rem;
  margin-right: 3rem;
  font-size: 1.4rem;
}

.text-tabela {
  min-width: 1rem;
  font-size: 1.2rem;
}
</style>
